/**
 * Resolves DVA bulk effect names generated by createCrudModel (bulkDelete{Namespace}, etc.).
 *
 * @param {string} namespace — e.g. 'areas', 'positions'
 * @param {'delete'|'activate'|'deactivate'} action
 */
export function getConfigBulkEffectName(namespace, action) {
  const suffix = namespace.charAt(0).toUpperCase() + namespace.slice(1);
  const names = {
    delete: `bulkDelete${suffix}`,
    activate: `bulkActivate${suffix}`,
    deactivate: `bulkDeactivate${suffix}`,
  };
  return names[action];
}

/**
 * Resolves bulk effect name with optional descriptor overrides (Tier 2 modules).
 *
 * @param {string} namespace
 * @param {'delete'|'activate'|'deactivate'} action
 * @param {{ delete?: string, activate?: string, deactivate?: string }} [overrides]
 */
export function resolveConfigBulkEffectName(namespace, action, overrides) {
  const custom = overrides?.[action];
  if (custom) return custom;
  return getConfigBulkEffectName(namespace, action);
}
